import { addSectorTotals, filterByYear } from "./data";
import { defaultAreaId, reportingYear } from "../constants";
import {
  calculateTheme1CumulativeGapByGniGroupChartData,
  calculateTheme1CumulativeGapBySectorChartData,
  calculateTheme1CurrentSpendingBySectorTableData,
  calculateTheme1CurrentSpendingChartData,
  calculateTheme1ProjectedFundingGapsByGniGroupTableData,
  calculateTheme1ProjectedFundingGapsBySectorTableData,
  calculateTheme1ProjectedFundingGapsWithinPublicSectorTableData,
  calculateTheme2MethodMixWithinSectorChartData,
  calculateTheme2ShareOfUsersChartData,
  calculateTheme2UsersByMethodChartData,
  calculateTheme2UsersBySectorTableData,
  calculateTheme3ShareOfUsersWithinPrivateSectorByMethodChartData,
  calculateTheme3ShareWithinPrivateSectorByGniGroupChartData,
  calculateTheme4ConsumptionCostChartData,
  calculateTheme4MethodMixOfUseVsCostChartData,
  calculateTheme4ShareOfConsumptionCostsByMethodChartData,
  calculateTheme4ShareOfConsumptionCostsVsUsersBySectorChartData,
  calculateTheme4ShareOfUsersVsCostChartData,
  calculateTheme5ChangeByGniGroupChartData,
  calculateTheme5ChangeByGniGroupTableData,
  calculateTheme5ChangeByMethodChartData,
  calculateTheme5ChangeInMethodMixChartData,
  calculateTheme5MethodMixChartData
} from "./widgetData";
import {
  calculateCountryExplorerCurrentChartData,
  calculateCountryExplorerProjectionChartData
} from "./countryExplorerData";
import calculateAnnexTableData from "./annexTableData";

const marshallData = database => {
  const allSectorTotalsData = addSectorTotals(database.data);
  const reportingYearData = filterByYear(database.data, reportingYear);

  const databases = {
    core: database,
    reportingYear: {
      ...database,
      data: reportingYearData
    },
    allSectorTotals: {
      ...database,
      data: allSectorTotalsData
    }
  };

  return {
    databases,
    widgetData: {
      theme1: {
        // Table 1.1
        currentSpendingBySectorTable: calculateTheme1CurrentSpendingBySectorTableData(
          databases
        ),
        // Figure 1.2
        currentSpendingChart: calculateTheme1CurrentSpendingChartData(
          databases
        ),
        // Table 1.2
        projectedFundingGapsBySectorTable: calculateTheme1ProjectedFundingGapsBySectorTableData(
          databases,
          defaultAreaId
        ),
        // Table 1.3
        projectedFundingGapsWithinPublicSectorTable: calculateTheme1ProjectedFundingGapsWithinPublicSectorTableData(
          databases,
          defaultAreaId
        ),
        // Table 1.4
        projectedFundingGapsByGniGroupTable: calculateTheme1ProjectedFundingGapsByGniGroupTableData(
          databases
        ),
        // Figure 1.3
        cumulativeGapBySectorChart: calculateTheme1CumulativeGapBySectorChartData(
          databases
        ),
        // Figure 1.4
        cumulativeGapByGniGroupChart: calculateTheme1CumulativeGapByGniGroupChartData(
          databases
        )
      },
      theme2: {
        // Figure 2.1
        usersByMethodChart: calculateTheme2UsersByMethodChartData(
          databases,
          defaultAreaId
        ),
        // Table 2.1
        usersBySectorTable: calculateTheme2UsersBySectorTableData(databases),
        // Figure 2.2
        shareOfUsersChart: calculateTheme2ShareOfUsersChartData(databases),
        // Figure 2.3
        methodMixWithinSectorChart: calculateTheme2MethodMixWithinSectorChartData(
          databases,
          3
        )
      },
      theme3: {
        // Figure 3.2
        shareOfUsersWithinPrivateSectorByMethodChart: calculateTheme3ShareOfUsersWithinPrivateSectorByMethodChartData(
          databases,
          defaultAreaId
        ),
        // Figure 3.3
        shareWithinPrivateSectorByGniGroupUserChart: calculateTheme3ShareWithinPrivateSectorByGniGroupChartData(
          databases,
          4
        ),
        // Figure 3.4
        shareWithinPrivateSectorByGniGroupCostChart: calculateTheme3ShareWithinPrivateSectorByGniGroupChartData(
          databases,
          6
        )
      },
      theme4: {
        // Figure 4.1
        methodMixOfUseVsCostChart: calculateTheme4MethodMixOfUseVsCostChartData(
          databases,
          defaultAreaId
        ),
        // Figure 4.3
        consumptionCostChart: calculateTheme4ConsumptionCostChartData(
          databases,
          defaultAreaId
        ),
        // Figure 4.4
        methodMixOfUseVsCostBySectorChart: calculateTheme4MethodMixOfUseVsCostChartData(
          databases,
          defaultAreaId,
          6
        ),
        // Figure 4.5
        shareOfUsersVsCostChart: calculateTheme4ShareOfUsersVsCostChartData(
          databases
        ),
        // Figure 4.6
        shareOfConsumptionCostsByMethodChart: calculateTheme4ShareOfConsumptionCostsByMethodChartData(
          databases
        ),
        // Figure 4.7
        shareOfConsumptionCostsVsUsersBySectorChart: calculateTheme4ShareOfConsumptionCostsVsUsersBySectorChartData(
          databases
        )
      },
      theme5: {
        // Figure 5.1
        changeByMethodUserChart: calculateTheme5ChangeByMethodChartData(
          databases,
          defaultAreaId,
          4
        ),
        // Figure 5.2
        changeInMethodMixChart: calculateTheme5ChangeInMethodMixChartData(
          databases,
          defaultAreaId
        ),
        // Table 5.1
        changeByGniGroupUserTable: calculateTheme5ChangeByGniGroupTableData(
          databases,
          4
        ),
        // Figure 5.3
        changeByGniGroupUserChart: calculateTheme5ChangeByGniGroupChartData(
          databases,
          4
        ),
        // Figure 5.4
        methodMixChart: calculateTheme5MethodMixChartData(databases, 14),
        // Figure 5.5
        changeByMethodCostChart: calculateTheme5ChangeByMethodChartData(
          databases,
          defaultAreaId,
          6
        ),
        // Table 5.2
        changeByGniGroupCostTable: calculateTheme5ChangeByGniGroupTableData(
          databases,
          6
        ),
        // Figure 5.6
        changeByGniGroupCostChart: calculateTheme5ChangeByGniGroupChartData(
          databases,
          6
        )
      },
      countryExplorer: {
        currentChart: calculateCountryExplorerCurrentChartData(
          databases,
          4,
          "Low income",
          undefined
        ),
        projectionChart: calculateCountryExplorerProjectionChartData(
          databases,
          4,
          "Low income",
          undefined
        )
      },
      annex: calculateAnnexTableData(databases, defaultAreaId)
    }
  };
};

export default marshallData;
